import axios from "axios";

const api = axios.create({
  baseURL: "/api", // common base
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30000,
});

// Optional: Add request interceptor (for token later)
api.interceptors.request.use(
  (config) => {
    // const token = localStorage.getItem("token");
    // if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// Optional: Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error.response || error.message);
    return Promise.reject(error);
  }
);

export default api;